import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  ViewChild,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';
import { PairLogoComponent } from '@components/pair-logo/pair-logo.component';
import { FormatPipe } from '@pipes/format.pipe';
import { ModalService } from '@services/modal-service.service';
import { chainSdTokens } from '@stores/token.store';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  FixedSizeVirtualScrollStrategy,
  RxVirtualScrollViewportComponent,
  RxVirtualFor,
  RxVirtualScrollWindowDirective,
} from '@rx-angular/template/experimental/virtual-scrolling';
import { ScrollbarDirective } from '@directives/scrollbar.directive';

@Component({
  selector: 'cmp-token-table',
  standalone: true,
  imports: [
    NgxPaginationModule,
    FixedSizeVirtualScrollStrategy,
    RxVirtualScrollViewportComponent,
    RxVirtualFor,
    RxVirtualScrollWindowDirective,
    PairLogoComponent,
    FormatPipe,
    ScrollbarDirective,
  ],
  templateUrl: './token-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``,
})
export class TokenTableComponent {
  @HostBinding('class') class = ['token-table'];
  @ViewChild('scrollviewPort') scrollviewPort;

  // paginationConfig: PaginationConfig = new PaginationConfig();
  page = signal(null);
  sortState: WritableSignal<{ sortBy: string; desc: boolean }> = signal({ sortBy: 'volume24h', desc: true });

  chainTokens = computed(() => {
    const tokens = chainSdTokens();
    const { sortBy, desc } = this.sortState();

    if (!tokens) return [];

    if (sortBy === 'name') {
      return tokens.slice().sort((a, b) => (desc ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)));
    }

    if (sortBy === 'volume24h') {
      return tokens
        .slice()
        .sort(
          (a, b) =>
            Number((desc ? b : a).data24h.volume24hData.total) - Number((desc ? a : b).data24h.volume24hData.total),
        );
    }

    return tokens.slice().sort((a, b) => Number((desc ? b : a)[sortBy]) - Number((desc ? a : b)[sortBy]));
  });

  constructor(private modalService: ModalService) {}

  openTokenPreview(address) {
    this.modalService.openTokenPreview(address);
  }

  onTransactionSortChange(sortBy) {
    if (this.sortState().sortBy === sortBy) {
      return this.sortState.update(({ sortBy, desc }) => ({ sortBy, desc: !desc }));
    }
    this.sortState.set({ sortBy, desc: true });
  }

  getSortIconClass(property: string) {
    if (property === this.sortState().sortBy) {
      return this.sortState().desc ? 'fas fa-angle-up' : 'fas fa-angle-down';
    } else {
      return 'fal fa-sort';
    }
  }

  // scrollToTransactionPage(page: number) {
  //   this.paginationConfig = new PaginationConfig(this.paginationConfig.itemsPerPage, page);
  //   this.scrollviewPort.scrollToIndex(page * 12 - 12);
  // }

  // // onScrolledIndexChange(page: number) {
  // onScrolledIndexChange(page: any) {
  //   const currentPage = Math.floor(page / 12) + 1;

  //   if (this.paginationConfig.currentPage !== currentPage) {
  //     this.paginationConfig = new PaginationConfig(this.paginationConfig.itemsPerPage, currentPage);
  //     this.page.set(currentPage);
  //   }
  // }

  // onPageChange(page: number): void {
  //   if (page === this.page()) {
  //     return;
  //   }

  //   this.page.set(page);
  //   this.scrollToTransactionPage(page);
  //   this.paginationConfig = new PaginationConfig(this.paginationConfig.itemsPerPage, page);
  // }
}
